import deMessages from './de'
import enMessages from './en'

export default {
  de: deMessages,
  en: enMessages,
}
